<template>
    <div class="BulletGraph">
        <div class="BulletGraph__header-bar">
            <div class="BulletGraph__header-container">
                <slot
                    name="header"
                    :data="chartData"
                >
                    {{ chartData.label }}
                </slot>
            </div>
            <div class="BulletGraph__info-container">
                <slot
                    name="info"
                    :data="chartData"
                >
                </slot>
            </div>
            <div class="BulletGraph__placeholder"></div>
            <div class="BulletGraph__percentage-container">
                <slot
                    name="percent"
                    :data="chartData"
                >
                </slot>
            </div>
        </div>
        <ThinChart
            v-if="type === 'thin'"
            :percent="chartData.percent"
        />
        <ThickChart
            v-if="type === 'thick'"
            :percent="chartData.percent"
            :color="chartData.color"
        />
        <MultiPartChart
            v-if="type === 'multi'"
            :chart-data="chartData"
        />
    </div>
</template>
<script>
import ThinChart from './_thin-chart.vue';
import ThickChart from './_thick-chart.vue';
import MultiPartChart from './_multi-part-chart.vue';
export default {
    name: 'BulletGraph',
    components: {
        ThinChart,
        ThickChart,
        MultiPartChart
    },
    props: {
        chartData: {
            type: [Object, Array],
            required: true,
        },
        type: {
            type: String,
            required: true
        },
    }
};
</script>
<style lang="scss">
    .BulletGraph {
        &__header-bar {
            display: flex;
            align-items: center;
            margin-bottom: 0.25rem;
        }
        &__info-container{
            margin-left: 0.5rem;
        }
        &__placeholder{
            flex-grow: 1;
        }
    }
</style>
